import { Record } from 'immutable';

const UserRecord = Record({
  email: null,
  firstName: null,
  lastName: null
});

export class User extends UserRecord {
  email: string;
  firstName: string;
  lastName: string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/auth/models/User.ts